import * as React from "react";
import { createContext, useContext } from "react";
import { Project } from "@radarly/models/project";

const ProjectContext = createContext<Project>(null);

export function useProject() {
  return useContext(ProjectContext);
}

interface IProps {
  children: React.ReactNode;
  project: Project;
}

export const ProjectProvider = ({ children, project }: IProps) => {
  return (
    <ProjectContext.Provider value={project}>
      {children}
    </ProjectContext.Provider>
  );
};
